import type { Dayjs } from 'dayjs';

import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';

import { Iconify } from 'src/components/iconify';

interface Props {
  startDate: Dayjs;
  endDate: Dayjs;
  setStartDate: (date: Dayjs) => void;
  setEndDate: (date: Dayjs) => void;
  hasWash?: boolean;
  getWashPrice: () => void;
}

export function InvoiceNewEditStatusDate(props: Props) {
  const { setEndDate, setStartDate, startDate, endDate, hasWash, getWashPrice } = props;

  const setStartDateHandler = (date: Dayjs) => {
    setStartDate(date);
    setEndDate(date.add(2, 'day'));
  };

  return (
    <Box
      sx={{
        p: 3,
        gap: 2,
        display: 'flex',
        bgcolor: 'background.neutral',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
      }}
    >
      <DatePicker
        onChange={(value) => value && setStartDateHandler(value)}
        label="Start dato"
        value={startDate}
        format="DD.MM.YYYY"
      />
      <DatePicker
        onChange={(value) => value && setEndDate(value)}
        label="Slut dato"
        value={endDate}
        format="DD.MM.YYYY"
        minDate={startDate}
      />

      {hasWash && (
        <Button
          component={Button}
          variant="contained"
          onClick={getWashPrice}
          startIcon={<Iconify icon="solar:restart-bold" />}
        >
          Udregn opvask
        </Button>
      )}
    </Box>
  );
}
